import { FiArrowRight } from "react-icons/fi";
import { AiOutlineLoading3Quarters } from "react-icons/ai";
import AuthRecaptcha from "./AuthRecaptcha";

const AuthSubmit = ({ captchaRef, captchaValue, onCaptchaChange, isLoading, label, loadingLabel }) => (
	<div className="auth-submit">
		<AuthRecaptcha ref={captchaRef} onChange={onCaptchaChange} />
		<button type="submit" className="auth-primary" disabled={!captchaValue || isLoading} aria-busy={isLoading}>
			{isLoading ? loadingLabel : label}
			{isLoading ? <AiOutlineLoading3Quarters className="animate-spin" aria-hidden="true" /> : <FiArrowRight size={18} aria-hidden="true" />}
		</button>
		{!captchaValue && <p className="auth-submit__hint" role="status">Complete the security check to continue.</p>}
	</div>
);

export default AuthSubmit;
